import React, { memo } from 'react';
import { IOrderItem } from '../../../providers';

import { Option } from './Option';

export const OrderOption = memo<NonNullable<IOrderItem['options']>[number]>((props) => {
  const totalPrice =
    props.totalPrice != null && (props.totalPrice / 100).toLocaleString('ru', { style: 'currency', currency: 'RUB' });

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  return <Option name={`${props.name!} ${props.factor! > 1 ? `× ${props.factor}` : ''}`}>{totalPrice}</Option>;
});
